import _ from 'lodash';
import { createReducer } from '../utils';
import {
  AUTH_LOGIN_USER_REQUEST,
  AUTH_LOGIN_USER_SUCCESS,
  AUTH_LOGIN_USER_FAILURE,
  AUTH_LOGOUT_USER,
  AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER,
  AUTH_OPEN_SOCIAL_WINDOW,
  AUTH_HANDLE_CONFIRM_REDIRECT,
  AUTH_POST_SIGNUP_REQUEST,
  AUTH_POST_SIGNUP_FAILURE,
  AUTH_FORGOT_PASSWORD_SUCCESS,
  AUTH_FORGOT_PASSWORD_FAILURE,
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_DISQUS_RESET,
  AUTH_DISQUS_SET,
  AUTH_PASSWORD_RESET_REQUEST,
  AUTH_PASSWORD_RESET_FAILURE,
  AUTH_PASSWORD_RESET_SUCCESS,
  UNSET_JANRAIN,
  AUTH_SET_RESET_TOKEN,
  AUTH_CLEAR_RESET_TOKEN,
  AUTH_USER_INFO_PANELS,
  DISABLE_REGISTRATION_PROMPT,
  AUTH_SET_ACTION,
  AUTH_SET_CAMERAS_API_TOKEN,
  AUTH_SET_SNAPSHOT_RATINGS,
  AUTH_BROADCAST_REQUEST,
  AUTH_BROADCAST_FAILURE,
  AUTH_BROADCAST_SUCCESS,
  AUTH_TEMPLATE_REQUEST,
  AUTH_TEMPLATE_FAILURE,
  AUTH_TEMPLATE_SUCCESS,
  AUTH_DELETE_USER_REQUEST,
  AUTH_DELETE_USER_SUCCESS,
  AUTH_DELETE_USER_FAILURE,
  SET_GQL_TOKEN, SET_COMMENT_USER,
} from '../constants';

const initialState = {
  token: null,
  userName: _.get(window, '__initialState__.auth.user_name', null),
  displayName: _.get(window, '__initialState__.auth.display_name', null),
  isAuthenticated: _.get(window, '__initialState__.auth.is_authenticated', false),
  isAuthenticating: false,
  statusText: null,
  isSuperuser: false,
  isStaff: false,
  provider: null,
  janrain: null,
  isFetching: false,
  isDeleting: false,
  deleted: false,
  disqus_sso: null,
  commentToken: null,
  gqlToken: null,
  loginSyncState: 0,
  snapshotRatings: {},
  resetPassword: {
    isFetching: false,
    success: false,
    uid: null,
    token: null,
  },
  user: {},
  infoPanels: null,
  promptRegistration: false,
  action: null,
  cameraToken: null,
  broadcast: {
    isFetching: false,
    success: false,
  },
  template: {
    isFetching: false,
    success: false,
    text: '',
  },
};

const getProvider = (provider) => {
  if (!provider) {
    return null;
  }
  const dictionary = {
    apple: {
      name: 'Apple',
      url: `${SERVER_OAUTH_URL}/apple?`,
      openid: '',
      popup: 'true',
      height: '400',
      width: '800',
    },
    google: {
      name: 'Google',
      url: `${SERVER_OAUTH_URL}/google?`,
      openid: '',
      popup: 'true',
      height: '400',
      width: '800',
    },
    facebook: {
      name: 'Facebook',
      url: `${SERVER_OAUTH_URL}/facebook?`,
      openid: '',
      popup: 'true',
      height: '400',
      width: '800',
    },
    twitter: {
      name: 'Twitter',
      url: `${SERVER_OAUTH_URL}/twitter?`,
      openid: '',
      popup: 'true',
      height: '400',
      width: '800',
    },
    yahoo: {
      name: 'Yahoo',
      url: `${SERVER_OAUTH_URL}/yahoo?`,
      openid: 'openid_identifier=https://me.yahoo.com/',
      popup: 'true',
      height: '450',
      width: '800',
    },
    // windowslive : {name:'Windows Live',url:'https://login.explore.org/liveid/start?', openid:'', popup:'true',height:'550',width:'900'},
    // aol : {name:'AOL',url:'https://login.explore.org/openid/start?', openid:'openid_identifier=https://openid.aol.com/'+userId, popup:'true',height:'550',width:'900'},
    // linkedin : {name:'LinkedIn',url:'https://login.explore.org/linkedin/start?', openid:'', popup:'true',height:'550',width:'900'},
    // blogger : {name:'Blogger',url:'https://login.explore.org/openid/start?', openid:'openid_identifier='+userId, popup:'true',height:'550',width:'900'},
    // flickr : {name:'Flickr',url:'https://login.explore.org/openid/start?', openid:'openid_identifier=https://flickr.com/', popup:'true',height:'450',width:'800'},
    // openid : {name:'OpenID',url:'https://login.explore.org/openid/start?', openid:'openid_identifier='+userId, popup:'true',height:'550',width:'900'},
    // wordpress : {name:'Wordpress',url:'https://login.explore.org/openid/start?', openid:'openid_identifier=https://'+userId+'.wordpress.com/', popup:'true',height:'550',width:'900'}
  };

  return dictionary[provider];
};
export default createReducer(initialState, {
  [AUTH_POST_SIGNUP_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true,
    });
  },

  [AUTH_POST_SIGNUP_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
      statusText: payload.data,
    });
  },
  [AUTH_LOGIN_USER_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true,
      isAuthenticating: true,
      statusText: null,
    });
  },
  [AUTH_LOGIN_USER_SUCCESS]: (state, payload) => {
    let panels = _.get(payload.user, 'preferences.info_panels', null);
    panels = panels && Object.keys(panels).length > 0;
    return Object.assign({}, state, {
      isFetching: false,
      isAuthenticating: false,
      isAuthenticated: true,
      // token: payload.token,
      disqus_sso: payload.user.disqus_sso,
      isSuperuser: payload.user.isSuperuser,
      userId: payload.user.user_id,
      avatarUri: payload.user.avatar_uri,
      isStaff: payload.user.isStaff,
      userName: payload.user.username,
      displayName: payload.user.display_name,
      email: payload.user.email,
      infoPanels: panels,
      snapshotRatings: payload.user.snapshot_ratings,
      commentToken: payload.user.comment_token,
      deleted: false,
      loginSyncState: 1,
    });
  },
  [AUTH_LOGIN_USER_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: false,
      isFetching: false,
      isDeleting: false,
      isSuperuser: false,
      isStaff: false,
      token: null,
      userName: null,
      displayName: null,
      userId: null,
      email: null,
      statusText: payload.statusText,
      disqus_sso: null,
      status: payload.status,
      snapshotRatings: {},
      commentToken: null,
      loginSyncState: -1,
    });
  },
  [AUTH_LOGOUT_USER]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticated: false,
      token: null,
      userName: null,
      displayName: null,
      userId: null,
      avatarUri: null,
      isSuperuser: false,
      isStaff: false,
      email: null,
      disqus_sso: null,
      statusText: null,
      snapshotRatings: {},
      commentToken: null,
      gqlToken: null,
      commentUser: {},
      loginSyncState: -1,
    });
  },
  [SET_GQL_TOKEN]: (state, payload) => {
    return Object.assign({}, state, {
      gqlToken: payload.gqlToken,
    });
  },
  [SET_COMMENT_USER]: (state, payload) => {
    return Object.assign({}, state, {
      commentUser: payload.user,
    });
  },
  [AUTH_SOCIAL_LOGIN_REQUEST_AND_SET_PROVIDER]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true,
      provider: getProvider(payload.provider),
    });
  },

  [AUTH_OPEN_SOCIAL_WINDOW]: (state, payload) => {
    return state;
  },

  [AUTH_HANDLE_CONFIRM_REDIRECT]: (state, payload) => {
    return Object.assign({}, state, {
      janrain: payload.data,
    });
  },

  [AUTH_FORGOT_PASSWORD_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true,
    });
  },

  [AUTH_FORGOT_PASSWORD_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
    });
  },

  [AUTH_FORGOT_PASSWORD_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
    });
  },
  [AUTH_DISQUS_RESET]: (state, payload) => {
    return Object.assign({}, state, {
      disqus_sso: null,
    });
  },
  [AUTH_DISQUS_SET]: (state, payload) => {
    return Object.assign({}, state, {
      disqus_sso: payload.disqus_sso,
    });
  },
  [AUTH_PASSWORD_RESET_REQUEST]: (state, payload) => {
    const resetPassword = state.resetPassword;
    _.extend(resetPassword, {
      isFetching: true,
      success: false,
    });
    return Object.assign({}, state, {
      resetPassword,
    });
  },
  [AUTH_PASSWORD_RESET_FAILURE]: (state, payload) => {
    const resetPassword = state.resetPassword;
    _.extend(resetPassword, {
      isFetching: false,
      success: false,
    });
    return Object.assign({}, state, {
      resetPassword,
    });
  },
  [AUTH_PASSWORD_RESET_SUCCESS]: (state, payload) => {
    const resetPassword = state.resetPassword;
    _.extend(resetPassword, {
      isFetching: false,
      success: true,
    });
    return Object.assign({}, state, {
      resetPassword,
    });
  },
  [UNSET_JANRAIN]: (state, payload) => {
    return Object.assign({}, state, {
      janrain: null,
    });
  },
  [AUTH_SET_RESET_TOKEN]: (state, payload) => {
    const resetPassword = state.resetPassword;
    _.extend(resetPassword, {
      token: payload.token,
    });
    return Object.assign({}, state, {
      resetPassword,
    });
  },
  [AUTH_CLEAR_RESET_TOKEN]: (state) => {
    const resetPassword = state.resetPassword;
    _.extend(resetPassword, {
      uid: null,
      token: null,
    });
    return Object.assign({}, state, {
      resetPassword,
    });
  },
  [AUTH_USER_INFO_PANELS]: (state) => {
    return Object.assign({}, state, {
      infoPanels: true,
    });
  },
  [DISABLE_REGISTRATION_PROMPT]: (state) => {
    return Object.assign({}, state, {
      promptRegistration: false,
    });
  },
  [AUTH_SET_ACTION]: (state, payload) => {
    return Object.assign({}, state, {
      action: payload.action,
    });
  },
  [AUTH_SET_CAMERAS_API_TOKEN]: (state, payload) => {
    return Object.assign({}, state, {
      cameraToken: payload.token,
    });
  },
  [AUTH_SET_SNAPSHOT_RATINGS]: (state, payload) => {
    return Object.assign({}, state, {
      snapshotRatings: payload.ratings,
    });
  },
  [AUTH_BROADCAST_REQUEST]: (state, payload) => {
    const broadcast = state.broadcast;
    _.extend(broadcast, {
      isFetching: true,
      success: false,
    });
    return Object.assign({}, state, {
      broadcast,
    });
  },
  [AUTH_BROADCAST_FAILURE]: (state, payload) => {
    const broadcast = state.broadcast;
    _.extend(broadcast, {
      isFetching: false,
      success: false,
    });
    return Object.assign({}, state, {
      broadcast,
    });
  },
  [AUTH_BROADCAST_SUCCESS]: (state, payload) => {
    const broadcast = state.broadcast;
    _.extend(broadcast, {
      isFetching: false,
      success: true,
    });
    return Object.assign({}, state, {
      broadcast,
    });
  },
  [AUTH_TEMPLATE_REQUEST]: (state, payload) => {
    const template = state.template;
    _.extend(template, {
      isFetching: true,
      success: false,
      text: '',
    });
    return Object.assign({}, state, {
      template,
    });
  },
  [AUTH_TEMPLATE_FAILURE]: (state, payload) => {
    const template = state.template;
    _.extend(template, {
      isFetching: false,
      success: false,
      text: '',
    });
    return Object.assign({}, state, {
      template,
    });
  },
  [AUTH_TEMPLATE_SUCCESS]: (state, payload) => {
    const template = state.template;
    _.extend(template, {
      isFetching: false,
      success: true,
      text: payload.template,
    });
    return Object.assign({}, state, {
      template,
    });
  },
  [AUTH_DELETE_USER_REQUEST]: (state) => {
    return Object.assign({}, state, {
      isDeleting: true,
    });
  },
  [AUTH_DELETE_USER_SUCCESS]: (state) => {
    return Object.assign({}, state, {
      isDeleting: false,
      deleted: true,
    });
  },
  [AUTH_DELETE_USER_FAILURE]: (state) => {
    return Object.assign({}, state, {
      isDeleting: false,
      deleted: false,
    });
  },
});
